import { useState } from 'react';
import { Container } from '@mui/material';
import { NavLink, useParams } from "react-router-dom";

import { useUserContext } from "../../../contexts/userContext";

import PermissionGate from "../../permissionGate";
import Navigation from "../../header";
import { Icons } from '../../icons';
import MaterialInventoryLabelForm from '../../forms/materialInventoryLabelForm';



const MaterialInventoryLabel = () => {
	const userContext = useUserContext();
	const { id } = useParams();
	const [isEditing, setIsEditing] = useState(false);

	const handleIsEditingChange = (isEditing: boolean) => {
		setIsEditing(isEditing);
	}

	return (
		<div className="hwi-material-inventory-add">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageMaterialInventory}>
					<section className="management-page-header">
						<div className="title">
							<NavLink to="/materialinventory" className="back-link">
								<Icons.GoBack fill="#9399ad" height="24px"></Icons.GoBack>
							</NavLink>
							{isEditing && "Editing "}Material Inventory - #{id}
						</div>
					</section>
					<section className="management-page-form">
						<MaterialInventoryLabelForm id={id} isEditingChange={handleIsEditingChange}></MaterialInventoryLabelForm>
					</section>
				</PermissionGate>
			</Container>
		</div>
	);
};

export default MaterialInventoryLabel;